import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateService } from '@root/shared/service/date.service';
import { TranslateService } from '@root/shared/service/translate.service';
import { PresetRanges } from './preset-ranges';

export const RANGE_DATE_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RangeDatePickerComponent),
  multi: true
};
/// 对 nz-range-date-picker 的简单封装
/// 唯一的不同点是input框的不同
/// 使用 nz-range-date-picker + nz-dropdown 来模拟
@Component({
  selector: 'host-range-date-picker',
  templateUrl: './range-date-picker.component.html',
  styleUrls: ['./range-date-picker.component.scss'],
  providers: [ RANGE_DATE_PICKER_VALUE_ACCESSOR ]
})
export class RangeDatePickerComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder = this.t.syncGet('placeholder.any_time');
  value: Date[];
  dropdownVisible = false;
  _registerOnChange: (value: any) => void = (r: any) => {};
  readonly presetRanges = PresetRanges;
  textView;
    // get textView () {
  //   if (this.value?.length > 1) {
  //     const [start, end] = this.value;
  //     return `${this.dateSrv.format(start, ['MD'])}~${this.dateSrv.format(end, ['MD'])}`;
  //   }
  // }

  constructor(
    private dateSrv: DateService,
    private t: TranslateService
  ) { }

  ngOnInit() {
  }
  onDatesChange (value) {
    this.onSelectDates(value);
    this.updateTextView();
  }

  onClickPreset (preset) {
    const { label, value } = preset;
    this.onSelectDates(value);
    this.updateTextView(this.t.syncGet('component.search.' + label));
  }

  registerOnChange(fn: any): void {    
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(value: Date[]): void {
    console.log('write value: ', value);
    
    this.value = value;
    this.updateTextView();
  }

  private onSelectDates(value: Date[]) {
    this.value = value;
    this._registerOnChange(this.value);
    console.log('register on change: ', this.value);
    
    this.closeDropdownPanel();
  }

  private closeDropdownPanel() {
    this.dropdownVisible = false;
  }

  private updateTextView (text?) {
    if (text) {
      this.textView = text;
    }
    else if (this.value?.length > 1) {
      const [start, end] = this.value;
      this.textView = `${this.dateSrv.format(start, ['MD'])}~${this.dateSrv.format(end, ['MD'])}`;
    } else {
      this.textView = null;
    }
  }

}
